import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignatureComponent } from './signature/signature.component';
import { SignupComponent } from './signup/signup.component';
import { ThanksComponent } from './thanks/thanks.component';
import { AuditTrailsComponent } from './audit-trails/audit-trails.component';
import { RequestedDocumentsComponent } from './requestedDocuments/requested-documents.component';
import { AlreadyLoggedInComponent } from './already-logged-in/already-logged-in.component';
import { OrRoomDetailComponent } from './or-room-detail/or-room-detail.component';
import { ProjectFromFormLinkComponent } from './ProjectFromFormLink/projectFromFormLink.component';
import { TabularSignatureComponent } from './tabularsignature/tabularsignature.component';
import { ExternalTaskComponent } from './external-task/external-task.component';
import { HTMLFormSignComponent } from './HTMLFormSign/HTMLFormSign.component';
import { HTMLThanksComponent } from './htmlthanks/htmlthanks.component';
import { ProjectDeletedComponent } from './project-deleted/project-deleted.component';
import { FileManagerDocumentsComponent } from './fileManagerDocuments/fileManager-documents.component';
import { FileManagerThanksComponent } from './fileManagerthanks/fileManagerthanks.component';
import { FileManagerViewerComponent } from './fileManagerFilesViewer/fileManager-viewer.component';
import { thanksExternalProjectComponent } from './thanksExternalProject/thanksExternalProject.component';
import { thanksExternalProjectProgressiveComponent } from './thanksExternalProjectProgressive/thanksExternalProjectProgressive.component';
import { PortalUIComponent } from './portal-ui/portal-ui.component';
import { AiDetailComponent } from '../middleware/shared/common/ai-detail/ai-detail.component';
import { ExamplesComponent } from '../middleware/shared/common/examples/examples.component';
import { TicketTaskComponent } from './ticket-task/ticket-task.component';
import { ThanksAddTicketComponent } from './thanksAddTicket/thanksAddTicket.component';
import { DeclineurlComponent } from './declineurl/declineurl.component';
import { FormFolderUrlComponent } from './formFolderUrl/formFolderUrl.component';
import { ThanksAssignToSomeOneComponent } from './thanksAssignToSomeOne/thanksAssignToSomeOne.component';
import { PortalSignatureComponent } from './portalsignature/portalsignature.component';
import { PortalPDFUploadComponent } from './portalpdfupload/portalpdfupload.component';


const routes: Routes = [

  {
   path:'aidetail',
   component: AiDetailComponent,
  },
  {
    path:'example',
    component: ExamplesComponent,
   },
  {
    path: 'signature',
    component: SignatureComponent,
  },
  {
    path: 'portalsignature',
    component: PortalSignatureComponent,
  },
  {
    path: 'portalpdfupload',
    component: PortalPDFUploadComponent,
  },
  {
    path: 'tabularsignature',
    component: TabularSignatureComponent,
  }, 
  {
    path:'projectFromFormLink',
    component: ProjectFromFormLinkComponent
  },
  {
    path:'formfolderurl',
    component: FormFolderUrlComponent
  },
  {
    path:'HtmlFormSign',
    component:HTMLFormSignComponent
  },
  {
    path:'documents',
    component: RequestedDocumentsComponent
  },
  {
    path:'fileManagerdocuments',
    component: FileManagerDocumentsComponent
  },
  {
    path:'fileManagerviewer',
    component: FileManagerViewerComponent
  },
  {
    path:'signup',
    component: SignupComponent
  },
  {
    path:'thanks',
    component: ThanksComponent
  },
  {
    path:'declineurl',
    component: DeclineurlComponent
  },
  {
    path:'thanksTicket',
    component: ThanksAddTicketComponent
  },
  {
    path:'thanksExternalProject',
    component: thanksExternalProjectComponent
  },
  {
    path:'thanksProgressiveProject',
    component: thanksExternalProjectProgressiveComponent
  },
  {
    path:'htmlthanks',
    component: HTMLThanksComponent
  },
  {
    path:'fileManagerthanks',
    component: FileManagerThanksComponent
  },
  {
    path:'audit',
    component: AuditTrailsComponent
  },
  {
    path:'alreadyLogin',
    component: AlreadyLoggedInComponent
  },
  {
    path:'ordetail',
    component: OrRoomDetailComponent
  },
  {
    path:'task',
    component: ExternalTaskComponent
  },
  {
    path:'tickettask',
    component: TicketTaskComponent
  },
  {
    path:'portal',
    component: PortalUIComponent
  },
  {
    path:'projectdeleted',
    component: ProjectDeletedComponent
  },
  {
    path:'thanksassigntosomeone',
    component: ThanksAssignToSomeOneComponent
  },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class unAuthenticateRoutingModule { }
